import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const LegalNoticePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* Header */}
      <PageHeader title={t('terms.legalNotice.title')} />

      {/* Contenu des Mentions Légales */}
      <div className="p-4">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="space-y-6 text-gray-700">
            {/* Section 1: Éditeur */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.legalNotice.publisher.title')}</h3>
              <p className="text-sm">{t('terms.legalNotice.publisher.name')}</p>
              <p className="text-sm">SIREN : {t('terms.legalNotice.publisher.siren')}</p>
              <p className="text-sm">APE : {t('terms.legalNotice.publisher.ape')}</p>
              <p className="text-sm">RNE : {t('terms.legalNotice.publisher.rneDate')}</p>
              <p className="text-sm">{t('terms.legalNotice.publisher.location')}</p>
              <p className="text-sm">{t('terms.legalNotice.publisher.contact')}</p>
            </section>

            {/* Section 2: Directeur */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.legalNotice.director.title')}</h3>
              <p className="text-sm">{t('terms.legalNotice.director.name')}</p>
            </section>

            {/* Section 3: Hébergement */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.legalNotice.hosting.title')}</h3>
              <p className="text-sm mb-2">{t('terms.legalNotice.hosting.azure')}</p>
              <p className="text-sm mb-2">{t('terms.legalNotice.hosting.supabase')}</p>
              <p className="text-sm mb-2">{t('terms.legalNotice.hosting.openai')}</p>
              <p className="text-sm">{t('terms.legalNotice.hosting.maps')}</p>
            </section>

            {/* Section 4: Propriété intellectuelle */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.legalNotice.intellectualProperty.title')}</h3>
              <p className="text-sm">{t('terms.legalNotice.intellectualProperty.content')}</p>
            </section>

            {/* Section 5: Limitation IA */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.legalNotice.aiContentLimitation.title')}</h3>
              <div className="space-y-2">
                <p className="text-sm mb-2">{t('terms.legalNotice.aiContentLimitation.intro')}</p>
                <p className="text-sm mb-2">{t('terms.legalNotice.aiContentLimitation.noGuarantee')}</p>
                <p className="font-medium text-sm mb-2">{t('terms.legalNotice.aiContentLimitation.infoTitle')}</p>
                <ul className="list-disc ml-6 space-y-1 mb-2">
                  <li className="text-sm">{t('terms.legalNotice.aiContentLimitation.info1')}</li>
                  <li className="text-sm">{t('terms.legalNotice.aiContentLimitation.info2')}</li>
                  <li className="text-sm">{t('terms.legalNotice.aiContentLimitation.info3')}</li>
                </ul>
                <p className="text-sm">{t('terms.legalNotice.aiContentLimitation.responsibility')}</p>
              </div>
            </section>

            {/* Lien vers la Politique de Confidentialité */}
            <section className="border-t pt-4 mt-6">
              <p className="text-sm text-gray-600">
                {t('common.forMoreInfo')} 
                <Link to="/settings/privacy" className="text-bleu2 hover:underline ml-1">
                  {t('terms.privacyPolicy.title')}
                </Link>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalNoticePage;
